import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class BillMedsService {

  private apiUrl: string;
      
  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization' : `Bearer ${token}`
      })
    }
  }

  getBillMeds(payload: (string | null) = null) {
    return this.http.get(
      this.apiUrl + '/bill-meds', this.getAuthHeaders()
    );
  }

  addBillMeds(payload: any) {
    return this.http.post(this.apiUrl + '/bill-meds', payload, this.getAuthHeaders());
  }

  updateBillMeds(payload: any) {
    return this.http.put(this.apiUrl + '/bill-meds/' + payload.id, payload, this.getAuthHeaders());
  }

  deleteBillMeds(payload: any) {
    return this.http.put(this.apiUrl + '/bill-meds/' + payload.id, payload, this.getAuthHeaders());
  }
}
